'use client';

import { FC } from 'react';
import { Select, SelectItem } from '@/components/ui';
import useNavigate from '@/hooks/use-navigate';
import useProductDetailPageContext from '@/hooks/use-product-detail-page-context';
import { useAppContext } from '@/providers/app-provider/app-provider';
import VariantCard from './variant-card/variant-card';

const VariantSelector: FC = () => {
  const navigate = useNavigate();
  const { isStudioPreview } = useAppContext<{ isStudioPreview?: boolean }>();

  const { variants } = useProductDetailPageContext();

  return (
    <div className="flex flex-col gap-4">
      {variants
        .filter(variant => variant.values.length > 1)
        .map(variant => (
          <div className="flex flex-col gap-2" key={variant.key}>
            <span className="font-medium">{variant.key}</span>
            <div className="flex gap-2">
              {variant.selectType === 'SELECT' ? (
                <Select
                  className="w-full @lg:w-1/2"
                  onChange={e => {
                    if (isStudioPreview) return;
                    if (e.target.value) {
                      navigate(`/product/${e.target.value}`);
                    }
                  }}
                  selectedKeys={
                    [variant.values.find(item => item.isActive)?.metaUrl].filter(
                      Boolean,
                    ) as Iterable<'all'>
                  }
                >
                  {variant.values.map(item => (
                    <SelectItem key={item.metaUrl}>{item.value}</SelectItem>
                  ))}
                </Select>
              ) : (
                variant.values.map((item, index) => (
                  <VariantCard key={item.id} item={variant} index={index} />
                ))
              )}
            </div>
          </div>
        ))}
    </div>
  );
};

export default VariantSelector;
